import { G2ReviewProps } from './g2-review-card'

export const g2Reviews: G2ReviewProps[] = [
  {
    name: 'Julie B.',
    position: 'Head of Data',
    image:
      'https://images.g2crowd.com/uploads/avatar/image/1957725/thumb_square_451f75ac4dd9dd76dba2c77a89b8771e.jpeg',
    rating: 5,
    reviewCopy: (
      <p>
        "Omni Analytics is a sweet spot between Looker and Mode. It's easy for
        your team to use, like Looker, but also lets tech-savvy folks dig into
        data with SQL queries.{' '}
        <strong>
          Plus, the Omni team is super quick to support and brainstorm on new
          ideas.
        </strong>
        "
      </p>
    ),
    reviewLink:
      'https://www.g2.com/survey_responses/omni-analytics-review-8774216?__cf_chl_tk=OPFDtueBW_eZSnhU36UW0dc40QTqiZJKqbiYTXjIxpQ-1718747870-0.0.1.1-5097',
  },

  {
    name: 'Verified User in Venture ',
    position: 'Capital & Private Equity',
    rating: 5,
    reviewCopy: (
      <p>
        "I am not a BI tool user nor a data engineer but am able to model data
        and create dashboards much easier than other tools we tried. The tool is
        fast and responsive. <strong>The team is helpful and supportive</strong>{' '}
        and if you want get under the hood it's very easy to do so"
      </p>
    ),
    reviewLink:
      'https://www.g2.com/products/omni-analytics-inc-omni-analytics/reviews/omni-analytics-review-8425326',
  },

  {
    name: 'Hari A.',
    image:
      'https://lh3.googleusercontent.com/a/ACg8ocIr-fcxCWxvgiJEjWtGfHqk_lLlt9YRdWZnohATMiPZ=s96-c',
    rating: 4.5,
    reviewCopy: (
      <p>
        A super powerful BI tool. Omni addresses many of the struggles in legacy
        BI tools with novel approaches. The team has built with the analyst in
        mind so well. With Omni, data engineering can end a step or two earlier
        and rest of the magic is taken care of by the Omni UI. I also love how
        quickly Omni iterates and launches new features.{' '}
        <strong>Customer support of the finest levels too.</strong>"
      </p>
    ),
    reviewLink:
      'https://www.g2.com/products/omni-analytics-inc-omni-analytics/reviews/omni-analytics-review-8810186',
  },

  {
    name: 'Gabi P.',
    rating: 5,
    reviewCopy: (
      <p>
        "As a non-technical person who is trying to understand how our customers
        are leveraging and getting value out of our product, I am always looking
        for ways to get my hands on data. The data will empower me to understand
        what happened so I can adjust or predict what will happen so I can
        better control the outcome. Omni is the first data tool I've used that
        allows me more freely (as a non-technical person) to do this. I don't
        have to rely on an engineer to do it for me. In a startup that is moving
        fast, this is imperative.{' '}
        <strong>
          Omni has also offered fantastic customer support, the team is smart
          and very responsive.
        </strong>
        "
      </p>
    ),
    reviewLink:
      'https://www.g2.com/products/omni-analytics-inc-omni-analytics/reviews/omni-analytics-review-9130774',
  },

  {
    name: 'Dylan H.',
    position: 'Senior Software Engineer',
    image:
      'https://lh3.googleusercontent.com/a-/AFdZucqgGEUvVrKWG2zUBfmJCdF1aw65ov1OwtLAeiwrPQ=s96-c',
    rating: 5,
    reviewCopy: (
      <p>
        "
        <strong>
          The support we've received from the Omni team has been truly
          incredible. Their customer service alone is a reason to switch.
        </strong>{' '}
        Every time we've needed help (even if it's just folks new to SQL who
        need a hand) the team has responded in minutes. If we find a bug, it's
        usually fixed in nothing flat. If we need a feature, we often see them
        add it within hours or days -- not weeks. Before you spin up anything
        else, give Omni a shot. It's worth it."
      </p>
    ),
    reviewLink:
      'https://www.g2.com/products/omni-analytics-inc-omni-analytics/reviews/omni-analytics-review-8304377',
  },

  {
    name: 'Sebastien C.',
    position: 'VP of Sales',
    rating: 5,
    reviewCopy: (
      <p>
        "
        <strong>
          The other thing that's most enjoyable about working with Omni is the
          team. They hit all the marks that you'd expect from a top vendor!
          Super responsive support, very friendly and helpful
        </strong>{' '}
        advices, new & super valuable features being released almost daily...
        it's a pleasure to see the speed at which the product is evolving. It
        already a great solution, it's getting better everyday and you're
        supported by one of the most knowledgeable team there is - it is
        absolutely the best value-for-money one can find in the BI Market right
        now."
      </p>
    ),
    reviewLink:
      'https://www.g2.com/products/omni-analytics-inc-omni-analytics/reviews/omni-analytics-review-8387859',
  },
]
